module.exports = __webpack_public_path__ + "img/logo.2e64971a.png";